var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('router-link',{attrs:{"to":"/"}},[_c('h1',[_vm._v("iKnowMagic "),_c('img',{attrs:{"src":require("@/assets/images/zen.svg"),"alt":"iknowmagic"}})]),_vm._v(" "),_c('h2',[_vm._v("A portfolio of Ilan Kaim")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3334a99a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = null
// module chunks = 